import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { SobreNosPage } from '../sobrenos/sobrenos';
import { PoliticaPage } from '../politica/politica';
import { TermosPage } from '../termos/termos';

@Component({
  selector: 'sobre',
  templateUrl: 'sobre.html'
})
export class SobrePage {

	public sobreNosPage = SobreNosPage;
	public politicaPage = PoliticaPage;
	public termosPage = TermosPage;

	constructor(public navCtrl: NavController) {}
}


// WEBPACK FOOTER //
// ./src/pages/sobre/sobre.ts